import { createFileRoute } from '@tanstack/react-router';
import PasswordResetRequestTemplate from '@/features/agent/account/templates/PasswordResetRequestTemplate';

export const Route = createFileRoute('/account/password/setting')({
  component: PasswordSettingPage,
});

function PasswordSettingPage() {
  return <PasswordResetRequestTemplate />;
}
